import script from "./UserRoleList.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserRoleList.vue?vue&type=script&setup=true&lang=ts"

import "./UserRoleList.vue?vue&type=style&index=0&id=67391c60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67391c60"]])

export default __exports__